import useSWRImmutable from "swr/immutable";
import { relativeURL } from "../relativeURL";

const fetcher = (url) => fetch(url).then((res) => res.json());

export function useSession(id) {
  const { data, error } = useSWRImmutable(
    () => (id ? relativeURL(`/api/session/${id}`) : null),
    fetcher
  );
  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  };
}
